enum DSAType {
    ARRAY = 'dsa_array',
    BIN_TREE = 'dsa_bin_tree',
}

export default DSAType;
